import { Component } from '@angular/core';
import { WhatsNewService, WhatsNewFeature } from '../../services/whats-new.service';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment/moment';

@Component({
    selector: 'app-whats-new-banner',
    templateUrl: './whats-new-banner.component.html',
    styleUrls: ['./whats-new-banner.component.scss'],
})
export class WhatsNewBannerComponent {
    features$: Observable<WhatsNewFeature[]>;
    showBanner$: Observable<boolean>;
    currentVersion: string;

    constructor(
        private whatsNewService: WhatsNewService,
        private translate: TranslateService
    ) {
        this.showBanner$ = this.whatsNewService.showBanner$;
        this.currentVersion = this.whatsNewService.getCurrentVersion();
        this.features$ = this.whatsNewService.getFeatures();
    }

    onDismiss(): void {
        this.whatsNewService.dismissBanner();
    }

    protected formatDate(date: string): string {
        const parsedDate = moment(date);
        const currentLang = this.translate.currentLang;
        return parsedDate.locale(currentLang).format('DD. MMM YYYY');
    }
}
